import { store } from "@/vuex/store.js"
import { setHeader,axiosGet, axiosPost,axiosPut, axiosDelete } from "../options/header"


export default {
 
 
  async getAllOsobe(personType, src_type=0) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/crm/all", {
        params: {
          personType,
          src_type
        },
         credentials: true

      });
    } catch (err) {
      console.log(err);
    }
  },
  

}

const fetchAllSalesStatus = async () => {
  try {
      const response = await axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + '/crm/sales-status');
      return response.data;
  } catch (error) {
      console.error('Error fetching sales status:', error);
  }
};

const createPhysPerson = async (uid) => {
  try {
      const response = await axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + '/crm/phys/'+uid);
      return response.data;
  } catch (error) {
      console.error('Error creating person:', error);
  }
};

const createLegalPerson = async (uid) => {
  try {
      const response = await axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + '/crm/leg/'+uid);
      return response.data;
  } catch (error) {
      console.error('Error creating person:', error);
  }
};




// Create a new service
const uploadCrmFiles = async (formData, person_id, person_type ) => {
 
  try {
      const response = await axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + '/crm/'+person_type+'/'+person_id+'/add-files', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
  } catch (error) {
      console.error("Error creating service:", error);
      throw error;
  }
};


const updateCrmStatus = async (data,person_id, person_type) => {
  try {
      const response = await axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + '/crm/'+person_type+'/'+person_id, data);
      return response.data;
  } catch (error) {
      console.error('Error creating sales status:', error);
  }
};

const updateCrmFileStructure = async (data,person_id, person_type) => {
  try {
      const response = await axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + '/crm/'+person_type+'/'+person_id+"/files", data);
      return response.data;
  } catch (error) {
      console.error('Error creating sales status:', error);
  }
};



export {
  createPhysPerson,
  createLegalPerson,
  uploadCrmFiles,
  fetchAllSalesStatus,
  updateCrmStatus,
  updateCrmFileStructure
}